export default __webpack_public_path__ + "static/media/logo_header.c6f84656.png";